import { HeaderLink as e, HeaderNavLink as t } from "../base/HeaderLink.js";
import { useRef as n } from "react";
import { Button as r, Chevron as i } from "@sprd/sprd-component-kit/v2";
import a from "clsx";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/components/Header/desktop/DesktopCyoMenu.tsx
function c({ item: c, isShown: l, linkComponent: u }) {
	let d = n(!1);
	return l && (d.current = !0), /* @__PURE__ */ s("div", {
		className: "relative shrink-0",
		children: [c.link ? /* @__PURE__ */ o(r, {
			size: "s",
			variant: "gradient",
			className: "justify-end self-end px-4!",
			asChild: !0,
			children: /* @__PURE__ */ o(e, {
				link: c.link,
				linkComponent: u,
				children: c.label
			})
		}) : null, /* @__PURE__ */ o("ul", {
			className: a(l ? "visible" : "invisible", "absolute top-full right-0 z-1 mt-3 flex w-90 flex-col gap-2 bg-neutral-100 px-4 py-6 shadow-xs"),
			children: (c.children ?? []).map((e) => e.link ? /* @__PURE__ */ o("li", { children: /* @__PURE__ */ s(t, {
				link: e.link,
				linkComponent: u,
				className: "group flex items-center gap-2 no-underline!",
				tabIndex: 0,
				children: [
					/* @__PURE__ */ o("div", {
						className: "size-16 shrink-0",
						children: d.current && e.image
					}),
					/* @__PURE__ */ s("div", {
						className: "flex grow flex-col group-hover:text-neutral-800",
						children: [/* @__PURE__ */ o("span", {
							className: "font-made text-inherit",
							children: e.label
						}), /* @__PURE__ */ o("span", {
							className: "text-sm text-inherit",
							children: e.subLabel
						})]
					}),
					/* @__PURE__ */ o(i, { className: "size-6 -rotate-90 group-hover:opacity-70" })
				]
			}) }, e.key) : null)
		})]
	});
}
//#endregion
export { c as DesktopCyoMenu };
